import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { salvarUsuario } from '../services/usuarios';
import './PortalCliente.css';

function PortalCadastro() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', senha: '' });
  const [status, setStatus] = useState('idle'); // idle | submitting | success | error
  const [errorMessage, setErrorMessage] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('submitting');
    setErrorMessage('');

    try {
      await salvarUsuario({
        email: form.email.trim(),
        senha: form.senha,
      });
      setStatus('success');
      setTimeout(() => navigate('/portal'), 1500);
    } catch (err) {
      setStatus('error');
      setErrorMessage(err.message || 'Erro ao cadastrar. Tente novamente.');
    }
  };

  return (
    <div className="portal-page">
      <div className="page-hero">
        <h1>Criar conta</h1>
        <p>Cadastre-se para acessar o Portal do Cliente.</p>
      </div>

      <section className="section">
        <div className="container">
          <div className="portal-login-box">
            {status === 'success' ? (
              <div className="portal-success">
                <h2>Conta criada!</h2>
                <p>Cadastro realizado com sucesso. Redirecionando para o login...</p>
                <Link to="/portal" className="btn btn-primary">
                  Ir para o login
                </Link>
              </div>
            ) : (
              <>
                <h2>Cadastro</h2>
                <p className="portal-subtitle">Informe seu e-mail e defina uma senha.</p>

                <form className="portal-login-form" onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="cadastro-email">E-mail</label>
                    <input
                      type="email"
                      id="cadastro-email"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      required
                      autoComplete="email"
                      placeholder="seu@email.com"
                      disabled={status === 'submitting'}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="cadastro-senha">Senha</label>
                    <div className="portal-password-wrap">
                      <input
                        type={showPassword ? 'text' : 'password'}
                        id="cadastro-senha"
                        name="senha"
                        value={form.senha}
                        onChange={handleChange}
                        required
                        autoComplete="new-password"
                        placeholder="Crie uma senha"
                        disabled={status === 'submitting'}
                        minLength={6}
                      />
                      <button
                        type="button"
                        className="portal-toggle-password"
                        onClick={() => setShowPassword((v) => !v)}
                        aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
                      >
                        {showPassword ? 'Ocultar' : 'Mostrar'}
                      </button>
                    </div>
                  </div>

                  {status === 'error' && (
                    <p className="form-error" role="alert">{errorMessage}</p>
                  )}

                  <button type="submit" className="btn btn-primary btn-large" disabled={status === 'submitting'}>
                    {status === 'submitting' ? 'Cadastrando...' : 'Cadastrar'}
                  </button>
                </form>

                <p className="portal-switch">
                  Já tem cadastro?{' '}
                  <Link to="/portal">Fazer login</Link>
                </p>
              </>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default PortalCadastro;
